import React, { useState } from 'react'
import { Grid, Typography } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import PopUpCustom from 'components/PopupCustom/PopUpCustom';
import InfoComplain from "assets/Image/ImgComplain/InfoComplain.png";
import { BtnCancelInModal, BtnCloseInModal } from 'components/Common/Button';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';

const CpnTypeRequestComplaint = (props) => {
    const {
        form,
        Option,
        setIsRequireObjInprogress,
        setIsRequireOtherInprogress,
        nStatusID,
        sMode,
    } = props;

    const [IsOpenHelper, setIsOpenHelper] = useState(false)

    const onhandleOpenHelper=()=>{
        setIsOpenHelper(!IsOpenHelper)
    }

    return (
        <>
            <Accordion header={"ข้อมูลจำแนกประเภทข้อร้องเรียน (ข้อมูลใช้ภายใน)"} isShowHelper={true} onOpenHelper={onhandleOpenHelper}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{marginTop:'-35px'}}>
                    <Grid item xs={12} sm={6}>
                        <AutoCompleteSelect
                            name="oTypeResolve"
                            options={Option.lstTypeResolve ?? []}
                            label={"ประเภทสำหรับแก้ไขปัญหา"}
                            required={true}
                            disabled={ nStatusID != 0 && (sMode === "view" || [3, 4, 5, 7, 8, 19, 20].includes(nStatusID))}

                            onChange={(event) => {
                                form.clearErrors("oReqInprogress")
                                if (event && event.value === "5") {
                                    setIsRequireObjInprogress(true)
                                }
                                else {
                                    setIsRequireObjInprogress(false)
                                }
                            }}
                        />
                    </Grid>
                    {form.getValues("oTypeResolve") && form.getValues("oTypeResolve").value === "5" ?
                        <>
                            <Grid item xs={12} sm={6}>
                                <AutoCompleteSelect
                                    name="oReqInprogress"
                                    options={Option.lstReqInprogress ?? []}
                                    label={"ข้อร้องเรียนเกี่ยวกับการดำเนินงาน"}
                                    required={true}
                                    disabled={ nStatusID != 0 && (sMode === "view" || [3, 4, 5, 7, 8, 19, 20].includes(nStatusID))}

                                    onChange={(event) => {
                                        form.clearErrors("sReqInprogress")
                                        if (event && event.value === "16") {
                                            setIsRequireOtherInprogress(true)
                                        }
                                        else {
                                            setIsRequireOtherInprogress(false)
                                        }
                                    }}
                                />
                            </Grid>
                        </> : null
                    }
                    {form.getValues("oTypeResolve") && form.getValues("oTypeResolve").value === "5" && form.getValues("oReqInprogress") && form.getValues("oReqInprogress").value === "16" ?
                        <>
                            <Grid item xs={12} sm={12}>
                                <InputCustomLabel
                                    id="sReqInprogress"
                                    name="sReqInprogress"
                                    label={"ข้อร้องเรียนเกี่ยวกับการดำเนินงาน (อื่นๆ)"}
                                    maxLength={500}
                                    required={true}
                                    disabled={nStatusID != 0 &&sMode === "view" || [3, 4, 5, 7, 8, 19, 20].includes(nStatusID)}
                                    fullWidth
                                />
                            </Grid>
                        </> : null
                    }
                    <Grid item xs={12} sm={6}>
                        <AutoCompleteSelect
                            name="oTypeCompliant"
                            options={Option.lstTypeCompliant ?? []}
                            label={"GBU Compliant Type"}
                            required={true}
                            disabled={nStatusID != 0 && sMode === "view" || [3, 4, 5, 7, 8, 19, 20].includes(nStatusID)}
                        />
                    </Grid>
                </Grid>
            </Accordion>
            <PopUpCustom
                setIsOpen={setIsOpenHelper}
                IsOpen={IsOpenHelper}
                sMaxWidth={'md'}
                JsxDialogHeader={
                    <>
                        <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <Typography>ข้อมูลเพิ่มเติม</Typography>
                            </Grid>
                            <Grid item>
                                <BtnCloseInModal txt={"ยกเลิก"} onClick={() => { onhandleOpenHelper() }} />
                            </Grid>
                        </Grid>
                    </>
                }
                JsxDialogContent={
                    <>
                        <img src={InfoComplain} alt={""} style={{ width: '100%' }} />
                    </>
                }
            />
        </>
    )
}

export default CpnTypeRequestComplaint